<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";
import isOrderableBusiness from "@/components/Business/orderable";

export default {
  name: "ManualBillingForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        internal_billing_id: null,
        external_maintenance_id: null,
        agency_id: null,
        business_id: null,
        group_slug: null,
        user_id: null,
        manual_billing_lines: [
          {
            spare_part_id: null,
            line_title: null,
            line_comment: null,
            unit_price: null,
            quantity: null,
          },
        ],
      },
      isBusy: false,
    };
  },
  computed: {
    options: function () {
      // La maintenance externe et l'agence passent par un autocomplete : ces deux champs
      // chargent eux-mêmes ce qu'ils affichent et n'attendent pas d'options ici.
      return {
        bill_type_slug_options: this.$store.getters[config.storeNamespace + "/getTypes"],
        spare_part_id_options: this.$store.getters["spare_part/getAll"].selectOptions("id", "name"),
        business_id_options: this.$store.getters["business/getByAgency"](this.form.agency_id)
          .filter(isOrderableBusiness)
          .selectOptions("id", ["number", " - ", "name"]),
        group_slug_options: this.$store.getters["renting_preparation/getGroups"],
        user_id_options: this.$store.getters["user/getByAgencyId"](this.form.agency_id).selectOptions("id", ["lastname", " ", "firstname"]),
      };
    },
  },
  watch: {
    "form.agency_id": function (agency) {
      this.$store
        .dispatch("business/getAllForSelectByAgency", {
          wait: true,
          agency: agency,
        })
        .then(() => {
          this.options.business_id_options = this.$store.getters["business/getByAgency"](agency)
            .filter(isOrderableBusiness)
            .selectOptions("id", ["number", " - ", "name"]);

          this.options.user_id_options = this.$store.getters["user/getByAgencyId"](agency)
            .selectOptions("id", ["lastname", " ", "firstname"]);
        });
    },
  },
  mounted() {
    let self = this;

    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            internal_billing_id: item.internal_billing ? item.internal_billing.id : null,
            billing_date: item.billing_date
              ? this.$moment(item.billing_date).format("YYYY-MM-DD")
              : null,
            external_maintenance_id: item.external_maintenance
              ? item.external_maintenance.id
              : null,
            agency_id: item.agency ? item.agency.id : null,
            business_id: item.business ? item.business.id : null,
            user_id: item.user ? item.user.id : null,
            manual_billing_lines: [],
          };
          item.manual_billing_lines.forEach((renting_preparation) => {
            self.form.manual_billing_lines.push({
              spare_part_id: renting_preparation.spare_part_id,
              line_title: renting_preparation.line_title,
              line_comment: renting_preparation.line_comment,
              unit_price: renting_preparation.unit_price,
              quantity: renting_preparation.quantity,
            });
          });

          this.$store.dispatch("business/getAllForSelectByAgency", {
            agency: item.agency.id,
          });

          this.isBusy = false;
        });
    }
    this.$store.dispatch("user/getAllForSelect");
    this.$store.dispatch("spare_part/getAll");
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ManualBilling/ManualBillingForm.vue